class Controls {
    constructor() {

        this.controlsFor = [...document.querySelectorAll('[data-control-for]')]

        this.init();
    }

    init() {

        if (!this.controlsFor.length) {
            return
        }
        this.controlsFor.map(el => el.addEventListener('click', (e) => {
            try {
                const inputField = document.getElementById(el.dataset.controlFor)

                if (!inputField || e.target === inputField) {
                    return
                }

                if (inputField.classList.contains('flatpickr-input')) {
                    const fp = inputField._flatpickr
                    fp.open()
                } else (
                    inputField.focus({ focusVisible: true })
                )

            } catch (error) {
                // Unable to set focus
            }

        }))


    }

}

export default Controls